
import { queryNumberList } from '@/utils/filter/filterUtils';
import { mapGetters, mapMutations } from 'vuex';
// import { AGE_OPTIONS } from '@/utils/filter/filterOptions';
import { initState } from '@/store/search/filter';
import {
  APPLY_FILTER,
  FILTER_RESET,
} from '@/utils/amplitudeEvent/amplitudeEvents.js';

import searchRouter from '@/plugins/searchRouter.client';
import BoxButton from '../common/btn/BoxButton.vue';
import DateNAgeFilter from './ScheduleNAgeFilter.vue';
import DetailedFilterContainer from './detailed/DetailedFilterContainer.vue';

export default {
  name: 'BottomFilterModalLayout',
  components: { DateNAgeFilter, DetailedFilterContainer, BoxButton },
  mixins: [searchRouter],
  data() {
    return {
      serializationFilterQueryData: '',
    };
  },
  computed: {
    ...mapGetters('search', [
      'activeBottomDrawerFilter',
      'isDateNAgeFilterActive',
    ]),
    ...mapGetters('search/filter', ['queryFilter']),
    /**
     * @description
     * 직렬화된 데이터 비교
     */
    isValid() {
      if (!this.serializationFilterQueryData) return true;
      return (
        this.serializationFilterQueryData === JSON.stringify(this.queryFilter)
      );
    },
  },
  // query 데이터를 store에 저장
  created() {
    const {
      selectedCategory,
      selectedDayOfWeek,
      selectedAge,
      selectedClassType,
      startTimeIdx,
      endTimeIdx,
      onlyDiscounted,
      selectedSubCategory,
    } = this.$route.query;

    this.SET_QUERY_TO_STORE({
      ...initState,
      ...this.$route.query,
      selectedDayOfWeek: queryNumberList(selectedDayOfWeek),
      selectedClassType: queryNumberList(selectedClassType),
      selectedAge: selectedAge ? queryNumberList(selectedAge) : [],
      selectedCategory:
        selectedCategory && !isNaN(parseInt(selectedCategory))
          ? parseInt(selectedCategory)
          : undefined,
      selectedSubCategory:
        selectedSubCategory && !isNaN(parseInt(selectedSubCategory))
          ? parseInt(selectedSubCategory)
          : undefined,
      onlyDiscounted: onlyDiscounted ? 'true' : undefined,
      startTimeIdx: startTimeIdx > -1 ? parseInt(startTimeIdx) : undefined,
      endTimeIdx: endTimeIdx ? parseInt(endTimeIdx) : undefined,
    });
  },
  mounted() {
    document.body.style.overflow = 'hidden';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.position = 'fixed';
    // 필터 설정 조작 확인을 위한 직렬화 데이터 보존
    this.serializationFilterQueryData = JSON.stringify(this.queryFilter);
  },
  destroyed() {
    document.body.style.overflow = 'auto';
    document.body.style.position = 'static';
  },
  methods: {
    ...mapMutations('search', ['SET_ACTIVE_BOTTOM_DRAWER_FILTER']),
    ...mapMutations('search/filter', [
      'RESET_AGE',
      'RESET_SCHEDULE',
      'RESET_MULTI_FILTER',
      'SET_QUERY_TO_STORE',
    ]),
    handleClose() {
      this.SET_ACTIVE_BOTTOM_DRAWER_FILTER('');
    },
    onClickResetAllFilter() {
      if (this.activeBottomDrawerFilter === 'age') this.RESET_AGE();
      if (this.activeBottomDrawerFilter === 'schedule') this.RESET_SCHEDULE();
      if (this.activeBottomDrawerFilter === 'multi') this.RESET_MULTI_FILTER();
      this.logUserCustomEvent(FILTER_RESET, {
        filterType: this.activeBottomDrawerFilter, // 'age' | 'schedule' | 'multi' |
      });
    },
    onClickFilterApply() {
      this.logUserCustomEvent(APPLY_FILTER);
      this.SET_ACTIVE_BOTTOM_DRAWER_FILTER('');
      this.onApplyButtonClick();
    },
  },
};
